import React, { useState } from "react"
import { useStaticQuery, graphql, Link } from "gatsby"

import logoSVG from "../images/ee-web-logo.svg"

const Navigation = () => {
  const menuLinks = useStaticQuery(graphql`
    query menuLinksQuery {
      contentfulNavigationData {
        mainNavigation {
          mainNav {
            link
            name
            subLinks {
              link
              name
            }
          }
        }
      }
    }
  `)

  const [isActive, setisActive] = useState(false);
  const { mainNav } = menuLinks.contentfulNavigationData.mainNavigation

  return (
    <nav className="navbar has-background-light is-transparent" role="navigation" aria-label="main navigation">
      
      <div className="navbar-brand is-align-items-center">
        <div>
          <Link to={"/"} className="navbar-item">
            <div className="image">
              <img src={logoSVG} alt="EtchingX" height="95" width="216"/>
            </div>
          </Link>
        </div>
        <button
          onClick={() => {
            setisActive(!isActive);
          }}
          onKeyDown={() => {
            setisActive(!isActive);
          }}
          className={`navbar-burger burger button is-text ${isActive ? "is-active" : ""}`}
          aria-label="menu"
          aria-expanded="false"
          data-target="navbarMain"
          tabIndex="-1"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </button>
      </div>

      <div id="navbarMain" className={`navbar-menu ${isActive ? "is-active" : ""}`}>
        <div className="navbar-end">
          {mainNav.map((topLevelLink) => (
            <div key={topLevelLink.name} className="navbar-item has-dropdown is-hoverable">
              <Link className={`navbar-link ${topLevelLink.subLinks && topLevelLink.subLinks.length > 0 ? null : `is-arrowless`}`} to={topLevelLink.link}>{topLevelLink.name}</Link>
                {topLevelLink.subLinks && topLevelLink.subLinks.length > 0
                  ? <div aria-label="submenu" className="navbar-dropdown">
                      {topLevelLink.subLinks.map(varName => (<Link key={varName.name} to={varName.link} className="navbar-item">{varName.name}</Link>))}
                    </div>
                  : null
                }
            </div>
          ))}
        </div>
      </div>
      
    </nav>
  )
}

export default Navigation
